import { SORT_LABELS, type SortMode } from '../utils/sort';
import { ViewerToggle } from './ViewerToggle';

interface Props {
  activeCount: number;
  sortMode: SortMode;
  onSortChange: (mode: SortMode) => void;
  viewer?: string;
  onViewerChange?: (v: string) => void;
}

const MODES: SortMode[] = ['smart', 'due', 'priority', 'age'];

export function ListFilters({
  activeCount,
  sortMode,
  onSortChange,
  viewer,
  onViewerChange,
}: Props) {
  return (
    <div className="list-filters">
      <span className="list-filters-count">
        {activeCount}
        <span className="list-filters-count-suffix"> active</span>
      </span>
      <div className="list-filters-right">
        {viewer !== undefined && onViewerChange && (
          <span className="list-filters-viewer">
            <ViewerToggle value={viewer} onChange={onViewerChange} />
          </span>
        )}
        <label className="sort-control">
          <span className="muted">Sort:</span>
          <select
            value={sortMode}
            onChange={(e) => onSortChange(e.target.value as SortMode)}
            aria-label="Sort tasks"
          >
            {MODES.map((m) => (
              <option key={m} value={m}>
                {SORT_LABELS[m]}
              </option>
            ))}
          </select>
        </label>
      </div>
    </div>
  );
}
